const PriceCard=({title,price,font,coupontype})=>
{
    return(
        <div style={{fontFamily:"Inter"}} className="flex justify-between sm:text-[14px] lg:text-[16px] leading-[19px] tracking-[1.5px]">
            <p className={`text-[#0C0C0C] font-[${font}]`}>{title}</p>
            {coupontype?coupontype==="Percentage"?<p className="text-[#8F8F8F]">{price}%</p>:<p className="text-[#8F8F8F]">₹{price}</p>:<p className="text-[#8F8F8F]">₹{price}</p>}
        </div>
    )
}
export default PriceCard